import styles from "./DefineUomPopupConfirmationButtons.module.scss";

import { IonButton, IonIcon } from "@ionic/react";
import { caretForwardOutline } from "ionicons/icons";
import { caretBackOutline } from "ionicons/icons";
interface IProps {
  onClickConfirm: any;
}

function DefineUomPopupConfirmationButtons(props: IProps) {
  return (
    <div
      className={`popup-bottom-confirmation-border-styles ${styles.bottomAreaContainer}`}
    >
      <div>
        <div className={styles.container}>
          <div className={styles.buttonsContainer}>
            <div className={`${styles.customConfirmationContainer} `}>
              <IonButton
                className={styles.confirmButton}
                onClick={() => {
                  if (props.onClickConfirm) {
                    props.onClickConfirm();
                  }
                }}
              >
                CONTINUE
              </IonButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DefineUomPopupConfirmationButtons;
